<template>
  <div>
    <line-chart
      chartId="rodent-statistic"
      :height="height"
      :options="options"
      :not-merge="true"
    ></line-chart>
  </div>
</template>

<script>
import LineChart from '@/components/Chart'
import _ from 'lodash'
import moment from 'moment'

export default {
  components: { LineChart },
  props: {
    data: Array,
    devs: Array
  },
  data() {
    return {
      height: 200
    }
  },
  computed: {
    options() {
      return {
        title: { show: false },
        tooltip: { trigger: 'item' },
        legend: {
          top: 12,
          left: 88,
          right: 100,
          itemWidth: 16,
          itemHeight: 10,
          textStyle: { fontSize: 14 }
        },
        grid: {
          show: false,
          top: 72,
          bottom: 80,
          right: '40%',
          tooltip: { trigger: 'axis' }
        },
        xAxis: { type: 'time', boundaryGap: false },
        yAxis: { type: 'value', minInterval: 1 },
        dataZoom: [
          {
            show: true,
            bottom: 12,
            left: 100,
            minValueSpan: 3600 * 24 * 1000 * 4
          }
        ],
        series: this.series
      }
    },
    series() {
      const categories = _.groupBy(this.data, 'namech')
      let series = Object.keys(categories).map(name => {
        const dd = _.groupBy(categories[name], d =>
          moment(d.collectTime).format('YYYY-MM-DD')
        )
        const days = Object.keys(dd)
        return {
          type: 'line',
          smooth: true,
          name,
          data: days.map(d => [d, dd[d].length])
        }
      })

      series.push({
        type: 'pie',
        center: ['75%', '60%'],
        radius: '60%',
        data: Object.keys(categories).map(name => {
          return {
            name,
            value: categories[name].length
          }
        })
      })

      return series
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.layout()
    })
  },
  methods: {
    layout() {
      this.height = this.$el.parentNode.offsetHeight - 60
    }
  }
}
</script>

<style lang="css" scoped></style>
